import React from "react";
import PretendardText from "./../../../../component/atoms/text/pretendardText";
import moment from "moment";
import "moment/locale/ko";
import { formatNumberWithCommas } from "../../../../util/formatNumber";

const SalesPeriodCustomTooltip = ({ active, payload, dateType }) => {
  // 스타일 객체
  const circleStyle = {
    width: "18px",
    height: "18px",
    borderRadius: "50%",
  };

  if (active && payload && payload.length) {
    return (
      <div
        style={{
          width: "fit-content",
          height: "fit-content",
          backgroundColor: "#313233",
          padding: "10px 12px",
          border: "1px solid rgba(255, 255, 255, 0.12)",
          boxShadow: "1px 1px 4px 0px rgba(0, 0, 0, 0.12)",
        }}
      >
        <p
          style={{
            fontFamily: "Pretendard",
            fontWeight: 600,
            fontSize: "13px",
            lineHeight: "22.75px",
            color: "#f3f3f3",
            marginBottom: "8px",
          }}
        >
          {dateType !== "month" && (
            <>{moment(payload[0].payload.date).format("YYYY-MM-DD (ddd)")}</>
          )}

          {dateType === "month" && (
            <>{moment(payload[0].payload.month).format("YY년 M월")}</>
          )}
          {/* {dateType === "day"
            ? `${moment
                (payload[0].payload.date)
                .format("YYYY-MM-DD")}(${moment
                (payload[0].payload.date)
                .local()
                .format("ddd")})`
            : dateType === "week"
            ? `${moment
                (payload[0].payload.startDate)
                .format("MM-DD")} (${moment
                (payload[0].payload.startDate)
                .local()
                .format("ddd")}) ~ ${moment
                (payload[0].payload.endDate)
                .format("MM-DD")} (${moment
                (payload[0].payload.endDate)
                .local()
                .format("ddd")})`
            : `${moment(payload[0].payload.month).format("YY")}년 ${moment
                (payload[0].payload.month)
                .format("M")}월`} */}
        </p>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <span
              style={{
                ...circleStyle,
                backgroundColor: "#34f3ff",
              }}
            />
            <PretendardText
              style={{
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "22.75px",
                color: "#aaa",
              }}
            >
              {`${formatNumberWithCommas(payload[1].value.toLocaleString())}건`}
            </PretendardText>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <span
              style={{
                ...circleStyle,
                backgroundColor: "#b658ff",
              }}
            />
            <PretendardText
              style={{
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "22.75px",
                color: "#aaa",
              }}
            >{`${formatNumberWithCommas(
              payload[0].value.toLocaleString()
            )}원`}</PretendardText>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default SalesPeriodCustomTooltip;
